import { Component, OnInit, forwardRef, ViewChild, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { AccountsService } from '~/services/administration.ts/accounts';

@Component({
    selector: 'accounts-dropdown',
    templateUrl: './accounts-dropdown.component.html',
    styleUrls: ['./accounts-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AccountsDropdownComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountsDropdownComponent implements OnInit, ControlValueAccessor {
  _accounts: any[] = [];
  _accountsFiltered: any[] = [];

  @Input() placeholder: string = 'Choose an Account';
  @Input() class: string = 'bordered current-step';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Output() accountChanged = new EventEmitter<any>();

  @ViewChild('kendo_combo_accounts') kendoComboAccounts: ComboBoxComponent;

  _value: any = null;
  isDisabled: boolean = false;

  onChange: any = () => {};
  onTouch: any = () => {};

  constructor(private _accountsService: AccountsService) {}

  ngOnInit(): void {
    this._loadAccounts();
  }

  _loadAccounts() {
    this._accountsService.getAccountsListing().subscribe((data: any) => {
      const accs = Array.isArray(data) ? data : (data?.body ?? data?.data ?? []);
      this._accounts = accs;
      this._accountsFiltered = this._accounts;
    });
  }

  _handleAccountsFilter(value: any) {
    if (!value) {
      this._accountsFiltered = this._accounts;
    } else {
      this._accountsFiltered = this._accounts.filter(
        (a: any) => a.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  _onValueChange(value: any) {
    this._value = value;
    this.onChange(value);
    this.onTouch();
    this.accountChanged.emit(value);
  }

  toggle(show: boolean) {
    if (this.kendoComboAccounts) {
      this.kendoComboAccounts.toggle(show);
    }
  }

  focus() {
    if (this.kendoComboAccounts) {
      this.kendoComboAccounts.focus();
    }
  }
}
